import { useState } from "react";
import secureLocalStorage from "react-secure-storage";
import { toast } from "react-toastify";
import { axiosInstance } from "../Config";
import Loader from "../Loader";
import moment from "moment";
import { CalculateTotal } from "./CalculateTotal";

const ClaimDetails = ({ data, OverallTotal, setClaimModal, getSessionsInfo, setMainTotal, setTotalData }) => {

    const users = secureLocalStorage.getItem("credentials");
    const [selecteddata, setSelectedData] = useState([]);
    const [Loading, setLoading] = useState(false);
    const [Total, setTotal] = useState(0);

    const handleCheckboxChange = (item, checked) => {
        let newSelectedData;
        if (checked) {
            // Add the selected item to the selecteddata array
            newSelectedData = [...selecteddata, item];
        } else {
            // Remove the deselected item from the selecteddata array
            newSelectedData = selecteddata.filter((dataItem) => dataItem.id !== item.id);
        }

        setSelectedData(newSelectedData);

        // Calculate the total amount based on the selected items
        const newTotal = newSelectedData.reduce((sum, selectedItem) => sum + (selectedItem?.amount || 0), 0);
        setTotal(newTotal);
    };

    // [{ "id": 141, "CustomerName": "Will jacks", "CourseName": "Block of 10 Hours – Driving Lessons", "StartDate": "2025-04-23", "Time": "02:00 PM - 04:00 PM", "SlotID": [1], "Amount": 68, "CourseCompleted": 20, "completedDays": 1, "remainingDays": 4 }]

    const handleClaimAmt = async (e) => {
        e.preventDefault();
        if (selecteddata?.length > 0) {
            try {
                setLoading(true);
                const formData = new FormData();
                formData.append("id", users.id);
                formData.append("lessondetails", JSON.stringify(selecteddata)); // Pass selected data as JSON string
                formData.append("lessons", selecteddata.map(i => i.id).toString()); // Pass selected data as JSON string
                formData.append("amount", Total);
                formData.append("totallesson", selecteddata?.length);

                const res = await axiosInstance.post('add-claim', formData, {
                    headers: {
                        Authorization: `Bearer ${users.token}`,
                        Accept: "application/json",
                        "Content-Type": "multipart/form-data",
                    }
                });

                if (res?.data?.success === true) {
                    toast.success('Claim Request Sent!');
                    setLoading(false);

                    const Total = CalculateTotal(res?.data?.LessonData || []);

                    console.log("Total new", Total)
                    setMainTotal(Total.Total);
                    setTotalData(Total.result);
                    setTotal(0)

                    setSelectedData([]);
                    setClaimModal(false);

                    setTimeout(() => {
                        getSessionsInfo();
                    }, 1000);

                } else {
                    toast.error('Something went wrong!');
                    setLoading(false);
                }
            } catch (error) {
                console.log(error);
                toast.error('Something went wrong !');
                setLoading(false);
            }

        } else {
            toast.error("Please Select Atleast One Lesson for Claim")
        }
    }; 

    return (
        <>
            {Loading && <Loader />}
            <div className="bg-gradientt p-4">
                {data.length > 0 ? (
                    <div className='p-2 pb-0'>
                        <div className='bg-white p-3 mt-4 d-flex justify-content-between'>
                            <h4 className='mb-0'>Lesson Details</h4>
                            <h4 className="mb-0 text-green">Total Amount : <i className="bi bi-currency-pound"></i> {OverallTotal.toFixed(2)}</h4>
                        </div>
                        <div className='table-responsive mt-4'>
                            <table className="jean-table table">
                                <tbody>
                                    {
                                        data.length > 0 && data.map((item) => {
                                            return (
                                                <tr key={item.id}>
                                                    <td>
                                                        <div className="therapist-info">
                                                            <div className='ps-2 py-3'>
                                                                <input
                                                                    type="checkbox"
                                                                    className='custom-radio-btn'
                                                                    name={`licence-${item.id}`}
                                                                    id={`licence-${item.id}`}
                                                                    onChange={(e) => handleCheckboxChange(item, e.target.checked)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="therapist-info">
                                                            <h4 className="mb-1 fs-5">Student Name</h4>
                                                            <p className="mb-0">
                                                                {item?.customerName ? item?.customerName : "--"}
                                                            </p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="therapist-info">
                                                            <h4 className="mb-1 fs-5">Course Name</h4>
                                                            <p className="mb-0">
                                                                {item?.courseName ? item?.courseName : "--"}
                                                            </p>
                                                        </div>
                                                    </td>
                                                    {/* <td>
                                                        <div className="therapist-info">
                                                            <h4 className="mb-1 fs-5">Car Type</h4>
                                                            <p className="mb-0">
                                                                {item?.cartype ? item?.cartype : "--"}
                                                            </p>
                                                        </div>
                                                    </td> */}
                                                    <td>
                                                        <div className="therapist-info">
                                                            <h4 className="mb-1 fs-5"> Date</h4>
                                                            <p className="mb-0">
                                                                {item?.bookingDate ? moment(item?.bookingDate).format("DD-MM- YYYY") : "--"}
                                                            </p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="therapist-info">
                                                            <h4 className="mb-1 fs-5">Time</h4>
                                                            <p className="mb-0">
                                                                {item?.slotTime ? item?.slotTime : "--"}
                                                            </p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="therapist-info">
                                                            <h4 className="mb-1 fs-5">Completed</h4>
                                                            <p className="mb-0">
                                                                {item?.completedDays || "--"}
                                                            </p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="therapist-info">
                                                            <h4 className="mb-1 fs-5">Remaining</h4>
                                                            <p className="mb-0">
                                                                {item?.remainingDays}
                                                            </p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="therapist-info">
                                                            <h4 className="mb-1 fs-5">Amount</h4>
                                                            <p className="mb-0">
                                                                <i className="bi bi-currency-pound me-1"></i>
                                                                {item?.amount ? item?.amount.toFixed(2) : "0"}
                                                            </p>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div className="d-flex justify-content-end align-items-center">
                            <h4 className="mb-0 me-4">Claim Amount : <i className="bi bi-currency-pound"></i> {Total.toFixed(2)}</h4>
                            <button className="button btn-green" type="button" onClick={handleClaimAmt}>Add Claim</button>
                        </div>
                    </div>
                ) : (
                    <div>
                        <div className="alert alert-success ps-4">No Claim Available !!</div>
                    </div>
                )}
            </div>
        </>
    );
};

export default ClaimDetails;
